module.exports = __webpack_public_path__ + "static/media/app.4fee3892.png";